export default __webpack_public_path__ + "static/media/TicketWithLines.06a41591.svg";